import React from 'react';
import { Node } from '@tiptap/pm/model';
import { Editor, NodeViewWrapper } from '@tiptap/react';
import { useCallback, useRef } from 'react';
import { Box } from '@mui/material';
import { borderRadius, customColors } from '../../../../assets/styles/themes/tokens';
import useScreenSize from '../../../useScreenSize';

interface ImageBlockViewProps {
  editor: Editor
  getPos: () => number
  node: Node & {
    attrs: {
      src: string
    }
  },
  selected: boolean
  updateAttributes: (attrs: Record<string, string>) => void
}

export const ImageBlockView = (props: ImageBlockViewProps) => {
  const { editor, getPos, node, selected } = props;
  const { isSmallScreen } = useScreenSize();
  const imageWrapperRef = useRef<HTMLDivElement>(null);
  const { src } = node.attrs;
 
  const onClick = useCallback(() => {
    editor.commands.setNodeSelection(getPos());
  }, [getPos, editor.commands]);

  return (
    <NodeViewWrapper>
      <Box 
        contentEditable={false} 
        ref={imageWrapperRef}
        sx={{
          display: 'flex',
          width: '100%',
        }}
      >
        <Box
          component='img'
          className='block'
          src={src}
          alt=''
          onClick={onClick}
          sx={{
            border: selected ? `1px solid ${customColors.lernsetListItem.selectedBorder}` : 'none',
            borderRadius: borderRadius.xs,
            maxWidth: '100%',
            width: isSmallScreen ? '100%' : 'auto',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
      </Box>
    </NodeViewWrapper>
  );
};

export default ImageBlockView;
